<template>
  <v-container fluid class="templates-container">
    <v-container class="mx-auto text-center mt-2" v-if="loading">
      <v-progress-circular
        class="loading"
        indeterminate
        color="#881E98"
      ></v-progress-circular>
    </v-container>
    <v-container v-else>
      <Header
        name="My templates"
        @search="onSearch"
        @sorting="onSort"
        @filtering="onFilter"
      />

      <v-container v-if="filteredTemplates.length === 0">
        <p class="text-center mt-4 font-weight-thin">There are no templates.</p>
      </v-container>

      <v-container
        v-else
        id="content-desktop"
        v-for="template in filteredTemplates"
        :key="template.id"
      >
        <TemplateItem :template="template" />
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import Header from "../../core/components/Header/Index";
import TemplateItem from "./PrivateTemplateItem";

import { mapGetters, mapActions } from "vuex";

import { search } from "../../utils/search";

export default {
  data() {
    return {
      loading: true,
      search: "",
      applicationProviders: [],
      sort: "",
    };
  },
  components: { Header, TemplateItem },
  computed: {
    ...mapGetters(["privateTemplates"]),
    filteredTemplates() {
      return this.applicationProviders.length
        ? this.sortTemplates(
            search(this.filterTemplates(), "TemplateName", this.search)
          )
        : this.sortTemplates(
            search(this.privateTemplates, "TemplateName", this.search)
          );
    },
  },
  methods: {
    ...mapActions([
      "getUserTemplates",
      "getTemplates",
      "getConnectedTemplates",
    ]),
    onSearch(value) {
      this.search = value;
    },
    onSort(sortType) {
      this.sort = sortType;
    },
    sortTemplates(templates) {
      if (this.sort === "Newest top")
        return templates.sort((current, next) =>
          current.CreatedAt < next.CreatedAt ? 1 : -1
        );
      else if (this.sort === "Oldest top")
        return templates.sort((current, next) =>
          current.CreatedAt > next.CreatedAt ? 1 : -1
        );
      else if (this.sort === "Alphabetical")
        return templates.sort((current, next) =>
          current.TemplateName.toLowerCase() < next.TemplateName.toLowerCase()
            ? -1
            : current.TemplateName.toLowerCase() >
              next.TemplateName.toLowerCase()
            ? 1
            : 0
        );
      else
        return templates.sort((current, next) =>
          current.TemplateName.toLowerCase() > next.TemplateName.toLowerCase()
            ? -1
            : current.TemplateName.toLowerCase() <
              next.TemplateName.toLowerCase()
            ? 1
            : 0
        );
    },
    onFilter(provider) {
      this.applicationProviders = provider;
    },
    filterTemplates() {
      const filteredData = [];
      this.applicationProviders.forEach((provider) =>
        this.privateTemplates.forEach((template) => {
          if (template.ApplicationProviderName === provider.title)
            filteredData.push(template);
        })
      );
      return filteredData;
    },
  },
  async beforeMount() {
    await this.getUserTemplates();
    this.loading = false;
  },
};
</script>

<style scoped>
.templates-container {
  margin-top: 84px;
}

.loading {
  margin-top: 60px;
}
</style>
